<template>
  <div class="share-container">
    <div v-if="showModal" class="bg">
      <div class="wrap">
        <div class="text">扫码申请免费试用</div>
        <img class="img" src="@/assets/qrcode.png" alt="" />
        <div class="bt" @click="showModal = false">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      showModal: false
    }
  },
  mounted () {

  },
  methods: {
    show () {
      console.log('show')
      this.showModal = true
    },
    hidden () {
      this.showModal = false
    }
  }
}
</script>

<style lang="less" scoped>
.share-container {
  .bg {
    position: fixed;
    z-index: 999999;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0,0,0,0.3)
  }
  .wrap {
    position: fixed;
    z-index: 999;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 700px;
    height: 460px;
    background: #FFFFFF;
    box-shadow: 0px 6px 24px 0px rgba(14,43,87,0.06);
    border-radius: 4px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .text {
      font-family: PingFangSC-Semibold;
      font-size: 24px;
      color: #222222;
      font-weight: 600;
      text-align: center;
    }
    .img {
      margin-top: 40px;
      width: 184px;
      height: 184px;
    }
    .bt {
      margin-top: 40px;
      width: 180px;
      height: 40px;
      background: #2F6AFF;
      border-radius: 4px;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #FFFFFF;
      font-weight: 400;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      &:active {
        opacity: 0.8;
      }
      &:hover {
        background-color: #4F95FF;
      }
    }
  }
  @media screen and (max-width: 1024px) {
    .wrap {
      width: 350px;
      height: 230px;
      .text {
        font-size: 12px;
      }
      .img {
        margin-top: 20px;
        width: 92px;
        height: 92px;
      }
      .bt {
        margin-top: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Userapply.vue